import { render } from "./HowWorks.vue?vue&type=template&id=1ed99ab6&scoped=true"
import script from "./HowWorks.vue?vue&type=script&lang=js"
export * from "./HowWorks.vue?vue&type=script&lang=js"

import "./HowWorks.vue?vue&type=style&index=0&id=1ed99ab6&lang=scss&scoped=true"
import "./HowWorks.vue?vue&type=style&index=1&id=1ed99ab6&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed99ab6"]])

export default __exports__